import lookup from 'country-code-lookup';

export const getCountryFromCode = nationality => {
  if (!nationality || nationality === 'ZZZ') {
    return '-';
  }
  const countryInfo = lookup.byIso(nationality);
  return countryInfo?.country || '-';
};
